/**
 * Que partes del sistema usa ESTE negocio.
 *
 * Farmacia San Carlos nacio como copia del punto de venta de Abarrotes Zuniga.
 * Algunas piezas de alla no le sirven a una farmacia, y en vez de borrarlas se
 * apagan aqui. Asi la copia sigue pareciéndose al original lo suficiente para
 * traer sus arreglos con cherry-pick, y el dia que la farmacia quiera una de
 * estas piezas se enciende con una linea.
 *
 * APAGAR ES ESCONDER, NO DESHABILITAR EN LA BASE. Las RPC siguen existiendo y
 * siguen validando permisos; lo que cambia es que la pantalla no ofrece el
 * camino. Ninguna regla de dinero depende de este archivo.
 */
export const FEATURES = {
  /**
   * Fiado: clientes con cuenta, abonos y la pantalla de Credito. La farmacia
   * cobra de contado (efectivo, tarjeta o transferencia). Apagado esconde la
   * pantalla, su renglon del menu y la pestaña "Fiar" del cobro.
   */
  credit: false,

  /**
   * Sucursales tipo bodega, que cobran por tonelada y por bulto. Apagado
   * esconde el selector "Que se vende aqui" de Sucursales.
   */
  bulkStores: false,

  /**
   * El recorrido publico `/demo`. El de origen cuenta la historia de una tienda
   * de abarrotes —granel, bascula, chiles que se secan— y enseñarselo a quien
   * abre el sistema de una farmacia confunde mas de lo que vende. Apagado
   * esconde el boton del acceso y la ruta cae en la Caja. Se enciende cuando
   * exista un recorrido de farmacia.
   */
  demo: false,
} as const;
